export const regionNameMap = {
    // Федеральные округа
    Центральный: "Central",
    "Северо-Западный": "Northwestern",
    Южный: "Southern",
    "Северо-Кавказский": "North Caucasian",
    Приволжский: "Volga",
    Уральский: "Ural",
    Сибирский: "Siberian",
    Дальневосточный: "Far Eastern",

    //Города Федерального значения
    Москва: "Moscow",
    "Санкт-Петербург": "Piter",
    Севастополь: "Sevastopol",

    //Республики
    "Республика Адыгея": "Republic of Adygeya",
    "Республика Башкортостан": "Republic of Bashkortostan",
    "Республика Бурятия": "Republic of Buryatia",
    "Республика Алтай": "Republic of Altai",
    "Республика Дагестан": "Republic of Daghestan",
    "Республика Ингушетия": "Republic of Ingushetia",
    "Кабардино-Балкарская Республика": "Kabardino-Balkarian Republic",
    "Республика Калмыкия": "Republic of Kalmykia",
    "Карачаево-Черкесская Республика": "Karachayevo-Circassian Republic",
    "Республика Карелия": "Republic of Karelia",
    "Республика Коми": "Komi Republic",
    "Республика Крым": "Republic of Crimea",
    "Республика Марий Эл": "Republic of Mari El",
    "Республика Мордовия": "Republic of Mordovia",
    "Республика Саха": "Republic of Sakha (Yakutia)",
    "Республика Северная Осетия":
        "Republic of North Ossetia \\u2013 Alania",
    "Республика Татарстан": "Republic of Tatarstan",
    "Республика Тыва": "Republic of Tuva",
    "Донецкая область": "Donetsk People's Republic",
    "Удмуртская Республика": "Udmurtian Republic",
    "Республика Хакасия": "Republic of Khakassia",
    "Чеченская Республика": "Chechen Republic",
    "Луганская область": "Lugansk People's Republic",
    "Чувашская Республика": "Chuvash Republic",

    //Края
    "Алтайский край": "Altai Territory",
    "Забайкальский край": "Trans-Baikal Territory",
    "Камчатский край": "Kamchatka Territory",
    "Краснодарский край": "Krasnodar Territory",
    "Красноярский край": "Krasnoyarsk Territory",
    "Пермский край": "Perm Territory",
    "Приморский край": "Primorye Territory",
    "Ставропольский край": "Stavropol Territory",
    "Хабаровский край": "Khabarovsk Territory",

    //Области
    "Амурская область": "Amur Region",
    "Архангельская область": "Arkhangelsk Region",
    "Астраханская область": "Astrakhan Region",
    "Белгородская область": "Belgorod Region",
    "Брянская область": "Bryansk Region",
    "Владимирская область": "Vladimir Region",
    "Волгоградская область": "Volgograd Region",
    "Вологодская область": "Vologda Region",
    "Воронежская область": "Voronezh Region",
    "Ивановская область": "Ivanovo Region",
    "Иркутская область": "Irkutsk Region",
    "Калининградская область": "Kaliningrad Region",
    "Калужская область": "Kaluga Region",

    //Края

    //Области
    "Кемеровская область": "Kemerovo Region \\u2013 Kuzbass",
    "Кировская область": "Kirov Region",
    "Костромская область": "Kostroma Region",
    "Курганская область": "Kurgan Region",
    "Курская область": "Kursk Region",
    "Ленинградская область": "Leningrad Region",
    "Липецкая область": "Lipetsk Region",
    "Магаданская область": "Magadan Region",
    "Московская область": "Moscow Region",
    "Мурманская область": "Murmansk Region",
    "Нижегородская область": "Nizhny Novgorod Region",
    "Новгородская область": "Novgorod Region",
    "Новосибирская область": "Novosibirsk Region",
    "Омская область": "Omsk Region",
    "Оренбургская область": "Orenburg Region",
    "Орловская область": "Orel Region",
    "Пензенская область": "Penza Region",

    "Псковская область": "Pskov Region",
    "Ростовская область": "Rostov Region",
    "Рязанская область": "Ryazan Region",
    "Самарская область": "Samara Region",
    "Саратовская область": "Saratov Region",
    "Сахалинская область": "Sakhalin Region",
    "Свердловская область": "Sverdlovsk Region",
    "Смоленская область": "Smolensk Region",
    "Тамбовская область": "Tambov Region",
    "Тверская область": "Tver Region",
    "Томская область": "Tomsk Region",
    "Тульская область": "Tula Region",
    "Тюменская область": "Tyumen Region",
    "Ульяновская область": "Ulyanovsk Region",
    "Челябинская область": "Chelyabinsk Region",

    "Ярославская область": "Yaroslavl Region",

    "Еврейская автономная область": "Jewish Autonomous Region",
    "Ненецкий автономный округ": "Nenets Autonomous Area",
    "Ханты-Мансийский автономный округ":
        "Khanty-Mansi Autonomous Area \\u2013 Yugra",
    "Чукотский автономный округ": "Chukotka Autonomous Area",
    "Ямало-Ненецкий автономный округ": "Yamal-Nenets Autonomous Area",
    "Запорожская область": "Zaporozhie Region",
    "Херсонская область": "Kherson Region",
};

// Названия регионов, приходящие с бэкенда в сокращённом или другом написании.
// Приводим их к каноническим ключам regionNameMap — на них завязаны карта,
// фильтры, список регионов и слайдер поглощения CO₂.
// Ключи regionNameMap теперь совпадают с написанием в backend/app/db/utils/init.py
// один в один, так что алиасов сейчас не требуется — таблица оставлена как задел
// на случай, если с бэка снова начнут приходить сокращённые/другие варианты.
export const regionNameAliases = {};

export const normalizeRegionName = (name) => {
    if (!name) return name;
    const trimmed = String(name).trim();
    return regionNameAliases[trimmed] || trimmed;
};

export const convertRegionName = (name) => {
    return regionNameMap[name] || name;
};

export const reverseConvertRegionName = (name) => {
    const reversed = Object.entries(regionNameMap).find(
        ([_, value]) => value === name
    );
    return reversed ? reversed[0] : name;
};

const regionMapping = {
    convertRegionName,
    reverseConvertRegionName,
};

export default regionMapping;
